import React from 'react';
import { withRouter } from 'react-router-dom';

class EditarConta extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centroId: 0,
            centro: "",
            id: 0,
            codConta: "",
            conta: "",
            tipoConta: "Tipo de Conta",
            tipoContaNome: "",
            tiposConta: [],
            naturezaConta: "Natureza da Conta",
            cultura: "",
            investimento: 0
        };

        this.changeCodConta = this.changeCodConta.bind(this);
        this.changeConta = this.changeConta.bind(this);
        this.changeTipoConta = this.changeTipoConta.bind(this);
        this.changeNaturezaConta = this.changeNaturezaConta.bind(this);
        this.changeCultura = this.changeCultura.bind(this);
        this.changeInvestimento = this.changeInvestimento.bind(this);
        this.salvar = this.salvar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    changeCodConta(e) {

        if (!isNaN(e.target.value)) {
            this.setState({ codConta: e.target.value });
        }

    }

    changeConta(e) {
        this.setState({ conta: e.target.value });
    }

    changeTipoConta(e) {
        this.setState({ tipoConta: e.target.value });
        let index = e.target.selectedIndex;
        this.setState({ tipoContaNome: e.target[index].text });
    }

    changeNaturezaConta(e) {
        this.setState({ naturezaConta: e.target.value });
    }

    changeCultura(e) {
        this.setState({ cultura: e.target.value });
    }

    changeInvestimento(e) {
        this.setState({ investimento: e.target.value });
    }

    salvar() {

        this.setState({ disabled: true });

        if (this.state.codConta === "") {

            this.props.errMsgHandler("Por favor, informe o código da conta.");
            this.setState({ disabled: false });

        } else if (this.state.conta === "") {

            this.props.errMsgHandler("Por favor, informe a descrição da conta.");
            this.setState({ disabled: false });

        } else if (this.state.tipoConta === "Tipo de Conta") {

            this.props.errMsgHandler("Por favor, informe o tipo de conta.");
            this.setState({ disabled: false });

        } else if (this.state.naturezaConta === "Natureza da Conta") {

            this.props.errMsgHandler("Por favor, informe a natureza da conta.");
            this.setState({ disabled: false });

        } else if (this.state.investimento === "") {

            this.props.errMsgHandler("Por favor, informe se a conta é de investimento.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                "id": this.state.id,
                "cod_conta": this.state.codConta,
                "conta": this.state.conta,
                "tipo_conta_id": this.state.tipoConta,
                "natureza_conta": this.state.naturezaConta,
                "cultura": this.state.cultura,
                "investimento": this.state.investimento
            };

            fetch("/api/conta/", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Conta editada com sucesso.");

                    let obj2 = {
                        row: {
                            id: this.state.id,
                            data: [
                                this.state.codConta,
                                this.state.conta,
                                this.state.tipoContaNome,
                                this.state.naturezaConta,
                                this.state.cultura
                            ]
                        }
                    };

                    this.props.history.push({
                        pathname: "/visualizarconta",
                        state: obj2
                    });

                }

            });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: [
                    this.state.codConta,
                    this.state.conta,
                    this.state.tipoContaNome,
                    this.state.naturezaConta,
                    this.state.cultura
                ]
            }
        };

        this.props.history.push({
            pathname: "/visualizarconta",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleContas !== "escrever") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;
        let id = this.props.location.state.id;
        let codConta = this.props.location.state.codConta;
        let conta = this.props.location.state.conta;
        let tipoContaNome = this.props.location.state.tipoConta;
        let tipoConta = this.props.location.state.tipoContaId;
        let naturezaConta = this.props.location.state.naturezaConta;
        let cultura = this.props.location.state.cultura;
        let investimento = this.props.location.state.investimento;

        this.setState({ centroId: centroId });
        this.setState({ centro: centro });
        this.setState({ id: id });
        this.setState({ codConta: codConta });
        this.setState({ conta: conta });
        this.setState({ tipoConta: tipoConta });
        this.setState({ tipoContaNome: tipoContaNome });
        this.setState({ naturezaConta: naturezaConta });
        this.setState({ cultura: cultura });
        this.setState({ investimento: investimento });

        fetch("/api/tipo_conta/centro/" + centroId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ tiposConta: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="editar-conta-title">Editar Conta</h1><br />
                <p id="editar-conta-centro">
                    <b>Centro:</b> { this.state.centro }
                </p><br />
                <form id="editar-conta-form">
                    <input type="text"
                        placeholder="Código"
                        value={ this.state.codConta }
                        onChange={ this.changeCodConta } />
                    <span Class="edconta-somente-numeros">
                        (Somente valores númericos.)
                    </span><br />
                    <input type="text"
                        placeholder="Conta"
                        value={ this.state.conta }
                        onChange={ this.changeConta } /><br />
                    <select value={ this.state.tipoConta } onChange={ this.changeTipoConta }>
                        <option value="Tipo de Conta">Tipo de Conta</option>
                        { this.state.tiposConta.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.cod_conta } - { item.nome }</option> ) }
                    </select><br />
                    <select value={ this.state.naturezaConta } onChange={ this.changeNaturezaConta }>
                        <option value="Natureza da Conta">Natureza da Conta</option>
                        <option value="Administrativa">Administrativa</option>
                        <option value="CAPEX">CAPEX</option>
                        <option value="CMV">CMV</option>
                        <option value="Comercial">Comercial</option>
                        <option value="Depreciação">Depreciação</option>
                        <option value="Dívida">Dívida</option>
                        <option value="Empréstimo">Empréstimo</option>
                        <option value="Entradas não operacionais de caixa">
                            Entradas não operacionais de caixa
                        </option>
                        <option value="Financiamento">Financiamento</option>
                        <option value="Impostos">Impostos</option>
                        <option value="Integralização de Capital">Integralização de Capital</option>
                        <option value="Juros">Juros</option>
                        <option value="Receita">Receita</option>
                        <option value="Transferência Interna">Transferência Interna</option>
                    </select><br />
                    <input type="text"
                        placeholder="Cultura"
                        value={ this.state.cultura }
                        onChange={ this.changeCultura } /><br />
                    <span Class="cadconta-somente-numeros">
                        <b>Investimento:</b>
                    </span><br /><br />
                    <select value={ this.state.investimento } onChange={ this.changeInvestimento }>
                        <option value={ 0 }>Não</option>
                        <option value={ 1 }>Aplicação</option>
                        <option value={ 2 }>Resgate</option>
                        <option value={ 3 }>Rendimento</option>
                    </select><br /><br />
                    <button type="button" id="edconta-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                    <button
                        type="button"
                        id="edconta-salvar-btn"
                        onClick={ this.salvar }
                        disabled={ this.state.disabled }>
                        Salvar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default withRouter(EditarConta);

